import { dollarsToPoints } from '../utils/points';
export function getDeviationPrice(deviation) {
    let dollarsPrice;
    let pointsPrice;
    if (deviation.commission) {
        dollarsPrice = deviation.commission.dollarsCost;
        pointsPrice = deviation.commission.pointsCost;
    } else if (deviation.pcp) {
        dollarsPrice = deviation.pcp.downloadDollarPrice;
        pointsPrice = deviation.pcp.downloadPrice;
    } else if (deviation.isAdoptable) {
        var _deviation_adoptable_fixedPrice, _deviation_adoptable;
        dollarsPrice = ((_deviation_adoptable_fixedPrice = (_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : _deviation_adoptable.fixedPrice) === null || _deviation_adoptable_fixedPrice === void 0 ? void 0 : _deviation_adoptable_fixedPrice.fixedPrice) || 0;
        pointsPrice = dollarsToPoints(dollarsPrice);
    }
    return {
        dollarsPrice,
        pointsPrice
    };
}
